import type { AxiosResponse } from 'axios';
import axios from 'axios';

import type { GenericSuccessData, SiteId, Channel, Url, Timestamp } from './common';
import { createSiteEndpointPath } from './common';

type UserId = number;

type ConnectionStatusId = number;

interface ConnectionStatus {
  /* eslint-disable camelcase */
  id: ConnectionStatusId;
  created_epoch_time: Timestamp;
  last_updated_epoch_time: Timestamp;
  site_id: SiteId;
  user_id: UserId;
  /* eslint-enable camelcase */
}

interface Channels extends GenericSuccessData {
  channels: Array<Channel>;
}

function createEndpointPath(siteId: SiteId): Url {
  return `${createSiteEndpointPath(siteId)}/token`;
}

export const SLACK_STATUS_QUERY_KEY = 'slack_status';

export function getConnectionStatus(siteId: SiteId): Promise<AxiosResponse<ConnectionStatus>> {
  const url = createEndpointPath(siteId);
  return axios.get(url);
}

export function disconnect(siteId: SiteId): Promise<AxiosResponse<GenericSuccessData>> {
  const url = createEndpointPath(siteId);
  return axios.delete(url);
}

export function getChannels(siteId: SiteId): Promise<AxiosResponse<Channels>> {
  return axios.get(`${createSiteEndpointPath(siteId)}/channels`);
}

export {
  get as getWidgetConfiguration,
  set as setWidgetConfiguration,
  update as updateWidgetConfiguration,
} from './widget-configuration';

export { get as getEnrollment, set as setEnrollment } from './enrollment';

export type { Channel } from './common';
